import { MRT_ColumnDef, MRT_TableInstance } from 'material-react-table';
import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

import { attachStaticFields } from 'utils/object';

type ToggleLowSupplyFilterButtonProps<TData extends Record<string, any>> = {
  table: MRT_TableInstance<TData>;
};

const lowSupplyColumnId = 'lowSupply';

export const ToggleLowSupplyFilterButton = attachStaticFields(
  ToggleLowSupplyFilterButtonComponent,
  {
    getLowSupplyColumn: <TData extends { lowSupply: boolean }>(): MRT_ColumnDef<TData> => ({
      header: 'Low supply',
      accessorFn: originalRow => originalRow.lowSupply,
      id: lowSupplyColumnId,
      enableColumnActions: false,
      enableSorting: false,
      filterFn: 'equals',
      enableColumnFilter: false,
      minSize: 87,
      maxSize: 87,
      size: 87,
      Cell: ({ row }) => (row.original.lowSupply ? 'yes' : 'no'),
      muiTableBodyCellProps: {
        align: 'center',
      },
    }),
  },
);

function ToggleLowSupplyFilterButtonComponent<
  TData extends Record<string, any> = Record<string, unknown>,
>({ table }: ToggleLowSupplyFilterButtonProps<TData>) {
  if (!table.getColumn(lowSupplyColumnId)) {
    throw new Error(
      `Column with id "${lowSupplyColumnId}" not found. Please add a column using ToggleLowSupplyFilterButton.`,
    );
  }
  const isLowSupply = table.getColumn(lowSupplyColumnId).getFilterValue() === false;
  const titleTooltip = isLowSupply ? 'Show low supply' : 'Hide low supply';
  return (
    <Tooltip title={titleTooltip}>
      <IconButton
        onClick={() => {
          table.setState(state => {
            const lowSupplyFilter = state.columnFilters.find(({ id }) => id === lowSupplyColumnId);
            return {
              ...state,
              columnFilters: lowSupplyFilter
                ? state.columnFilters.filter(({ id }) => id !== lowSupplyColumnId)
                : [...state.columnFilters, { id: lowSupplyColumnId, value: false }],
            };
          });
        }}
      >
        {isLowSupply ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
}
